module.exports = __webpack_public_path__ + "static/Event_deets-418572361fb3a4beab5968fab189bee7.png";